var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useRef } from 'react';
import { flexRender } from '@tanstack/react-table';


import { GrabIcon, RowWrapper } from "./DraggableRow";









/* eslint-disable comma-spacing */
const TableRow = ({
  draggableRow,
  row,
  dndContext,
  enableSelection,
  item
}) => {
  const previewRef = useRef(null);
  const icons =
  draggableRow && dndContext && item ?
  [/*#__PURE__*/_jsx(GrabIcon, { row: row, dndContext: dndContext, previewRef: previewRef, item: item })] :
  [];
  const isSubGroup = row.depth > 0;
  let bg = row.getCanExpand() || isSubGroup ? 'bg-primary-50' : '';
  bg = row.getCanExpand() && row.getIsExpanded() ? 'bg-primary-100' : bg;

  return /*#__PURE__*/(
    _jsx(RowWrapper, {
      className: `${bg} border-b`,
      draggableRow: draggableRow,
      row: row,
      dndContext: dndContext,
      innerRef: previewRef },
    `row${row.id}`,

    row.getVisibleCells().map((cell, columnIndex) => {var _cell$column$columnDe;
      const isSelect = cell.column.id === 'checkbox-select';
      const firstColumnClass =
      isSelect || draggableRow && columnIndex === 0 ? 'flex items-center gap-3' : '';

      let border = '';
      if (
      isSelect && (
      isSubGroup && enableSelection && columnIndex === 1 ||
      isSubGroup && !enableSelection && columnIndex === 0))
      {
        border = 'border-r-2 border-primary-300';
      }

      return /*#__PURE__*/(
        _jsx("td", {

          className: `${firstColumnClass} ${isSelect ? 'px-2' : 'px-6'} ${border} py-2 ${
          ((_cell$column$columnDe = cell.column.columnDef.meta) === null || _cell$column$columnDe === void 0 ? void 0 : _cell$column$columnDe.contentClassName) || ''
          }` }, cell.id,

        icons[columnIndex],
        flexRender(cell.column.columnDef.cell, cell.getContext())
        ));

    })
    ));

};

export { TableRow };